import { render, staticRenderFns } from "./DocumentImageManager.vue?vue&type=template&id=17d0696f"
import script from "./DocumentImageManager.vue?vue&type=script&lang=js"
export * from "./DocumentImageManager.vue?vue&type=script&lang=js"
import style0 from "./DocumentImageManager.vue?vue&type=style&index=0&id=17d0696f&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports